import { useEffect, useState } from "react";
import DesktopLayout from "./desktopLayout";
import MobileLayout from "./mobileLayout";

export default function ResponsiveLayout({ children }) {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const content = (
    <div className="w-full h-full bg-(--neutral-50) text-(--neutral-900)">
      {children}
    </div>
  );

  return isDesktop
    ? <DesktopLayout>{content}</DesktopLayout>
    : <MobileLayout>{content}</MobileLayout>;
}